const mixin = {
  constants: {
    appTitle: "OSAPM",
    appSubtitle: "Obra Social Agentes de Propaganda Médica"
  }
}

const ConstMixinPlugin = {
  install(Vue, options) {
    Vue.mixin({
      data() {
        return mixin
      }
    })
  }
}
export default ConstMixinPlugin
